import { defineMessages } from "react-intl";

// Mirrors the backend limit (saleor/order/parcel_shop.py).
export const PONTO_RECOLHA_ADDRESS_MAX_LENGTH = 500;

export const pontoRecolhaMessages = defineMessages({
  addressLabel: {
    id: "aMkiJY",
    defaultMessage: "Pickup point (Ponto de Recolha) address",
    description: "input label, GLS pickup point address entered when shipping",
  },
  addressHelperText: {
    id: "yTiM6f",
    defaultMessage:
      "The shop the parcel is sent to (name, street, postcode, town). It is included in the shipping email to the customer.",
    description: "input helper text, GLS pickup point address",
  },
  cardTitle: {
    id: "N07lTx",
    defaultMessage: "Pickup point (Ponto de Recolha)",
    description: "fulfill page card title for GLS pickup point orders",
  },
  storePickupNotice: {
    id: "P2LnLQ",
    defaultMessage:
      "In-store pickup order: nothing is shipped, so there is no tracking number or shipping email. The customer collects it at the store.",
    description: "fulfill page notice for in-store pickup orders",
  },
});
